export default __webpack_public_path__ + "static/media/island_8_with_objects.64100b7c.png";